<template>
    <v-btn class="ma-2" :color="card.color" :dark="card.error" @click="$emit('click')" block x-small :style="{ textTransform: 'none' }">
        <strong>{{ item.operator }} </strong>
        <v-spacer class="d-none d-lg-block" />
        <div class="d-none d-lg-block">
            {{ card.msg }}
        </div>
    </v-btn>
</template>

<script>
import PaymentOperator from "@/enum/PaymentOperator";

export default {
    props: {
        item: {
            type: Object,
        },
    },

    computed: {
        card() {
            let msg = null;

            if (this.item.last4) {
                msg = `(${this.item.last4})`;
            }

            if (this.item.operator == PaymentOperator.STRIPE) {
                let card = null;
                if (this.item.infoOnInsert && this.item.infoOnInsert.paymentMethod && this.item.infoOnInsert.paymentMethod.card) {
                    card = this.item.infoOnInsert.paymentMethod.card;
                } else if (this.item.moreInfo && this.item.moreInfo.paymentMethod && this.item.moreInfo.paymentMethod.card) {
                    card = this.item.moreInfo.paymentMethod.card;
                }
                if (card) {
                    msg = `${card.brand} (${card.last4})`;
                    if (card.wallet) {
                        msg += ` [${card.wallet.type} - ${card.wallet.dynamic_last4}]`;
                    }
                }
            } else if (this.item.operator == PaymentOperator.PAGAR_ME) {
                if (this.item.infoOnInsert.data && this.item.infoOnInsert.data.last_transaction && this.item.infoOnInsert.data.last_transaction.card) { // pagarme
                    msg = `${this.item.infoOnInsert.data.last_transaction.card.brand} (${this.item.infoOnInsert.data.last_transaction.card.last_four_digits})`;
                }
            } else if (this.item.operator == PaymentOperator.MERCADO_PAGO_PIX || this.item.operator == PaymentOperator.MERCADO_PAGO) {
                if (this.item.infoOnInsert.payment_method) { // mercado pago
                    if (this.item.infoOnInsert.payment_method.id == 'pix') {
                        msg = `${this.item.infoOnInsert.payment_method.id} (${this.item.infoOnInsert.transaction_details.transaction_id})`;
                    } else if (this.item.infoOnInsert.payment_method == 'credit_card' && this.item.infoOnInsert.card) {
                        msg = `${this.item.infoOnInsert.payment_method.id} (${this.item.infoOnInsert.card.last_four_digits})`;
                    }
                }
            }

            // Sem cor quando OK para o botão acompanhar o tema (claro/escuro)
            return msg ? { msg: msg, color: undefined, error: false } : { msg: "Erro", color: "red", error: true };
        }
    }
};
</script>